var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"moderate"},[_c('resource-list',{attrs:{"title":_vm.listTitle,"is-loading":_vm.isLoading,"resources":_vm.filteredResources,"is-editing":"true"}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46e04774","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/LibraryModerate.vue
// module id = HP7i
// module chunks = 0